import Link from "next/link";
import MetaIcon from "@/v2-components/core/icon/meta-icon";
import SteamIcon from "@/v2-components/core/icon/steam-icon";
import PSVRIcon from "@/v2-components/core/icon/ps-vr-icon";
import SimRacingIcon from "@/v2-components/core/icon/sim-racing-icon";
import PCPlatformIcon from "@/v2-components/core/icon/pc-platform-icon";
import OculusIcon from "@/v2-components/core/icon/oculus-icon";
import { cn } from "@/libs/utils";

interface GamePlatformLinkProps {
  href: string;
  icon: string;
  bgColor: string;
  title: string;
  className?: string;
}

const IconMap = {
  MetaIcon,
  SteamIcon,
  PSVRIcon,
  SimRacingIcon,
  PCPlatformIcon,
  OculusIcon,
};

export function GamePlatformLink({
  href,
  icon,
  bgColor,
  title,
  className,
}: GamePlatformLinkProps) {
  const IconComponent = IconMap[icon as keyof typeof IconMap];

  return (
    <Link
      href={href}
      className={cn(
        `flex h-[60px] w-full items-center gap-3 overflow-hidden rounded-xl bg-coolgray-10 px-4 backdrop-blur-[20px] transition-colors smd:h-36 smd:w-40 smd:flex-col smd:justify-center smd:bg-white/20 smd:px-6 smd:hover:bg-white/50`,
        className,
      )}
    >
      <div
        className={cn(
          `flex h-8 w-8 items-center justify-center rounded-[999px] text-white smd:h-16 smd:w-16`,
          bgColor,
        )}
      >
        <IconComponent className="smd:h-8 smd:w-8" />
      </div>
      <p className="justify-start text-lg">{title}</p>
    </Link>
  );
}
